module.exports = "data:image/gif;base64,R0lGODlhtAABALMMAN/f34yMjNTU1JGRkcPDw9ra2peXl7q6urGxsaioqJ+fn8zMzAAAAAAAAAAAAAAAACH5BAEAAAwALAAAAAC0AAEAAAQvEBSxyEFJmcG678FgKAlyEItQSJSFadwnz3RNh2N5pgV9ZbUcwib7KYjIpExIiwAAOw=="


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/Default/slider-v.gif
// module id = 1650
// module chunks = 28